import React from 'react'

export default () => {
  return (
    <div>
        <h2>Based on your results, this type of dizziness is most likely being caused by   <strong className="text-decoration" data-tip="Labyrinthitis is typically caused by a viral infection that has spread to inflame the vestibular and cochlear nerve in the inner ear, along with a bacterial infection  that causes dizziness and hearing problems/ringing in the ears.">Labyrinthitis</strong> </h2>
        <p>In addition to feelings of dizziness and being off-balance, people with labyrinthitis often experience trouble hearing or ringing in the ears.</p>
        <p>For best treatment and recovery, we recommend visiting a healthcare provider for definitive diagnostics and treatment.</p>
        <p>Patients will typically receive medication to lessen the severity of symptoms in addition to antivirals and antibacterials to treat the cause and thus get rid of the symptoms altogether.</p>
        <a id="Neuritis Labyrinthitis" href="https://www.rehabmart.com/post/why-am-i-dizzy-top-5-causes-of-dizziness-what-to-do" target="_black">read more about this condition ></a>
    </div>
  )
}
